/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-11-08, 11:53:38
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-02, 15:36:41
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

import { API } from '@/config';
import { hPrepareConnectionsFilterObjectToApiRequirements } from '@/utils/helpers';

import {
  FILL_NOTIFY_STATUSES_DEFINITION, FILL_CONNECTIONS_LIST, // CLEAR_CONNECTION_LIST,
  SET_CONNECTIONS_DOWNLOAD_PARAMS,
} from './mutation-types';

export default {
  async getNotifyStatuses({ commit }) {
    try {
      const notifyStatuses = (await API.get('/settings/notifyStatuses')).data.data;
      commit(FILL_NOTIFY_STATUSES_DEFINITION, { notifyStatuses });
    } catch (error) {
      console.log(error);
    }
  },

  setConnectionsDownloadParams({ commit, state, dispatch }, params) {
    const { filters, page } = params;
    const newFilters = { ...state.connections.filters, ...filters };
    commit(SET_CONNECTIONS_DOWNLOAD_PARAMS, { filters: newFilters, page });
    dispatch('getConnections');
  },

  clearConnetionsDownloadFilter({ commit, dispatch }, actionConditions) {
    const conditions = {
      andGetConnections: true,
      ...actionConditions,
    };
    const defaultFilters = {
      calling_number: [],
      widget_id_fk: [],
      date: [],
      agent_id: [],
      session_id: [],
      notify_status: [],
      effect: [],
      direction: [],
    };
    commit(SET_CONNECTIONS_DOWNLOAD_PARAMS, { filters: defaultFilters });
    if (conditions.andGetConnections) dispatch('getConnections');
  },

  async getConnections({ commit, state }) {
    try {
      const { page } = state.connections;
      const filters = hPrepareConnectionsFilterObjectToApiRequirements(state.connections.filters);
      const params = { page, ...filters };
      const connections = (await API.get('/connections', { params })).data.data;
      commit(FILL_CONNECTIONS_LIST, { connections });
    } catch (error) {
      console.log(error);
    }
  },

  async update(context, params) {
    try {
      await API.post('/connection', params);
    } catch (error) {
      console.log(error);
    }
  },
};
